import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { initialState, NAME, TranslationMode } from './configs'

const translationSlice = createSlice({
  name: NAME,
  initialState,
  reducers: {
    setLocale: (state, action) => {
      state.locale = action.payload
      state.isDefaultLocale = state.defaultLocale.value === action.payload.value
    },
    setDefaultLocale: (state, action) => {
      state.defaultLocale = action.payload
    },
    setIsInitialized(state, action: PayloadAction<boolean>) {
      state.isInitialized = action.payload
    },
    setMode(state, action: PayloadAction<TranslationMode>) {
      state.mode = action.payload
    },
  },
})

export const { setLocale, setDefaultLocale, setIsInitialized, setMode } = translationSlice.actions
export const translationReducer = translationSlice.reducer
